import { keepPreviousData } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { api } from '../../../utils/api.ts';
import { useExplorerView } from './use-explorer-query-params.ts';

export function useExplorerTotalSummary() {
    // We need to validate if the user applied any filters
    const { filters, state, combinedFilters } = useExplorerView();

    const { window, billingStatus, customDateRange } = state;
    const hasFilters = Object.keys(filters).some((key) => !isEmpty(filters[key as keyof typeof filters]));

    const { data, isLoading } = api.platoUser.query.explorer.getExplorerSummary.getTotalWithFilters.useQuery(
        {
            filters: combinedFilters,
            window,
            billingStatus,
            customDateRange,
        },
        {
            enabled: hasFilters,
            placeholderData: hasFilters ? keepPreviousData : undefined,
        },
    );

    if (isLoading || !data || !hasFilters) {
        return {};
    }

    return { summary: data };
}
